module.exports = __webpack_public_path__ + "img/header.1db659f5.svg";